<template>
  <div class="product-group">
    <h2 class="group-title">媒体</h2>
    <span class="group-description">来各个应用寻找我的痕迹</span>
    <div class="group-items">
      <laputa-card v-for="card in mediaList" :card="card" :key="card.id"/>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue'
const mediaList = ref([]);
import request from "@/api/request";
import showToast from "@/utils/toast";
import LaputaCard from "@/components/common/LaputaCard.vue";

const queryMediaToolList = async () => {
  try {
    const response = await request.get("/v1/api/tool/queryMediaToolList");
    const resp = response.data;
    if (resp.responseCode === '0000') {
      mediaList.value = resp.data;
    } else {
      showToast(resp.responseDesc);
    }
  } catch (e) {
    showToast(e.message);
  }
}
onMounted(async () => {
  await queryMediaToolList()
})
</script>

<style scoped>
.product-group {
  margin: 0;
  width: 80%;
}

h2.group-title {
  font-size: 32px;
  margin-bottom: 0;
}

.group-description {
  font-size: 14px;
  color: var(--laputa-common-secondary-font-color);
}

.group-items {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: minmax(200px, auto);
  gap: 10px;
  align-items: stretch;
  justify-items: stretch;
}

/* 平板：1024及以下（包含11寸iPad） → 2列 */
@media screen and (max-width: 1024px) {
  .product-group {
    width: 88%;
  }

  h2.group-title {
    font-size: 28px;
  }

  .group-items {
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
  }
}
/* 大屏手机 / 小平板：768px以下 → 两列 */
@media screen and (max-width: 768px) {
  .product-group {
    width: 92%;
    margin: 0 auto; /* 兜底水平居中，防止偏左 */
  }

  h2.group-title {
    font-size: 24px;
  }

  .group-description {
    font-size: 13px;
  }

  .group-items {
    /* 关键：minmax(0, 1fr) 防止卡片内容撑破列宽溢出屏幕 */
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    margin-top: 16px;
  }

  /* 关键：grid 子项允许收缩，和你之前工具页那个裁切问题同源 */
  .group-items > * {
    min-width: 0;
    width: 100%;
  }
}
</style>
